// src/utils/RatingByTypeChart.js
const RatingByTypeChart = (Response = {}) => {
  console.log('Raw Rating Response:', Response);

  // ✅ Extract backend data safely
  const data =
    Array.isArray(Response?.statusSummary) && Response.statusSummary.length > 0
      ? Response.statusSummary
      : [
        { label: '1 Star', count: 12 },
        { label: '2 Star', count: 6 },
        { label: '3 Star', count: 9 },
        { label: '4 Star', count: 92 },
        { label: '5 Star', count: 93 }
      ];

  // ✅ Calculate total ratings
  const totalCount =
    typeof Response?.totalRatings === 'number' && Response.totalRatings > 0
      ? Response.totalRatings
      : data.reduce((sum, item) => sum + (item.count || 0), 0);

  // ✅ Color map
  const ratingColors = {
    '1 Star': '#FF4D4F', // Red
    '2 Star': '#FF7A45', // Orange
    '3 Star': '#FFC53D', // Yellow
    '4 Star': '#73D13D', // Green
    '5 Star': '#36CFC9'  // Teal
  };

  return {
    title: {
      text: `${totalCount}`,
      subtext: 'Total Ratings',
      left: '49%',
      top: '45%',
      textAlign: 'center',
      textVerticalAlign: 'middle',
      textStyle: {
        fontSize: 26,
        fontWeight: 'bold',
        fontFamily: 'Inter, Poppins, sans-serif',
        color: '#333'
      },
      subtextStyle: {
        fontSize: 14,
        color: '#888',
        fontFamily: 'Inter, Poppins, sans-serif'
      }
    },
    tooltip: {
      trigger: 'item',
      formatter: params => {
        const { name, value, percent } = params;
        return `<b>${name}</b><br/>🎟️ Count: ${value}<br/>📊 Percent: ${percent}%`;
      }
    },
    legend: { show: false },
    series: [
      {
        name: 'Rating',
        type: 'pie',
        radius: ['35%', '65%'],
        center: ['50%', '50%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 8,
          borderColor: '#fff',
          borderWidth: 4
        },
        label: {
          show: true,
          position: 'outside',
          formatter: params =>
            `${params.name}: ${params.value}\n(${params.percent}%)`,
          fontSize: 12,
          fontFamily: 'Inter, Poppins, sans-serif',
          color: '#444',
          lineHeight: 16
        },
        labelLine: {
          show: true,
          length: 15,
          length2: 10,
          lineStyle: { color: '#aaa' }
        },
        data: data.map(item => ({
          name:
            item.label && item.label.toLowerCase().includes('star')
              ? item.label
              : 'Unrated', // ✅ Handle backend label mismatch
          value: item.count || 0,
          itemStyle: { color: ratingColors[item.label] || '#ccc' }
        }))
      }
    ]
  };
};

export default RatingByTypeChart;
